import { ArrowUpRight, Mail } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Container } from './Container';

const footerLinks = [
  { label: 'Services', href: '/services' },
  { label: 'Solutions', href: '/solutions' },
  { label: 'Products', href: '/products' },
  { label: 'Company', href: '/about' },
  { label: 'Contact', href: '/contact' },
  { label: 'Privacy', href: '/privacy' },
  { label: 'Terms', href: '/terms' },
];

export function Footer() {
  return (
    <footer className="border-t border-slate-800/70 bg-[#05080e]">
      <Container className="py-14 sm:py-16">
        <div className="flex flex-col gap-10 md:flex-row md:items-start md:justify-between">
          <div className="max-w-xs">
            <Link to="/" className="focus-ring inline-flex" aria-label="CrimsonSky IT home">
              <img
                src="/branding/crimsonsky-logo.png"
                alt="CrimsonSky IT"
                className="block h-auto w-52 max-w-full object-contain object-left"
                loading="lazy"
                decoding="async"
              />
            </Link>
            <p className="mt-5 text-sm leading-6 text-slate-500">
              Software systems for ambitious businesses. South Africa-first, built for what’s next.
            </p>
          </div>
          <div className="grid grid-cols-2 gap-x-14 gap-y-4 text-sm sm:gap-x-20">
            {footerLinks.map((item) => (
              <Link
                key={item.href}
                to={item.href}
                className="focus-ring text-slate-400 hover:text-white"
              >
                {item.label}
              </Link>
            ))}
          </div>
        </div>
        <div className="mt-14 flex flex-col gap-4 border-t border-slate-800/70 pt-6 text-xs text-slate-600 sm:flex-row sm:items-center sm:justify-between">
          <p>© {new Date().getFullYear()} CrimsonSky IT. South Africa. All rights reserved.</p>
          <div className="flex items-center gap-4">
            <a
              href="mailto:contact@crimsonskyit.co.za"
              className="focus-ring inline-flex items-center gap-2 hover:text-slate-300"
              aria-label="Email CrimsonSky IT"
            >
              <Mail size={15} /> contact@crimsonskyit.co.za
            </a>
            <Link
              to="/terms"
              className="focus-ring inline-flex items-center gap-1 hover:text-slate-300"
            >
              Terms <ArrowUpRight size={13} />
            </Link>
          </div>
        </div>
      </Container>
    </footer>
  );
}
